import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/austin")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Awnings Austin & Outdoor Curtains Austin TX | Texas Awning Company",
      description: "Awnings Austin, outdoor curtains Austin, commercial awnings Texas — welded storefront, restaurant and patio canopies. Texas awning company serving Austin & Travis County.",
      image: hero,
      socialTitle: "Awnings Austin, Outdoor Curtains & Commercial Awnings Texas — Texas Made Shade",
      socialDescription: "Awnings Austin + outdoor curtains Austin + commercial awnings Texas. Welded aluminum + Sunbrella canvas storefront, restaurant and patio canopies for Travis County.",
      keywords: "Awnings Austin TX, awnings Austin, awning company Austin, awning company Austin TX, awning companies Austin, outdoor curtains Austin, Texas awning company, commercial awnings Austin, commercial awnings Texas, storefront awnings Austin, restaurant awnings Austin, residential awnings Austin, sail shades Austin, shade sails Austin, patio covers Austin, pergola covers Austin, metal awnings Austin, canvas awnings Austin, retractable awnings Austin, Texas Made Shade",

    }),
    scripts: cityHeadScripts("Austin", "Travis County"),
  }),
  component: () => <CityHomePage city="Austin" region="Travis County" />,
});
